module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col1",
    class: [(_vm.m_column === -1) ? 'choose-col' : 'nochoose-col'],
    on: {
      "click": function($event) {
        return _vm.chooseMember(-1)
      }
    }
  }, [_c('span', {
    class: [(_vm.m_column === -1) ? 'tag' : 'tag_2'],
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("全部成员")])]), _vm._v(" "), _vm._l((_vm.memberList), function(member, i) {
    return _c('div', {
      staticClass: "col2",
      class: [(_vm.m_column === i) ? 'choose-col' : 'nochoose-col'],
      on: {
        "click": function($event) {
          return _vm.chooseMember(i)
        }
      }
    }, [_c('span', {
      class: [(_vm.m_column === i) ? 'tag' : 'tag_2'],
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(member))])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27670d3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/components/GcSingleSelection.vue
// module id = 1574
// module chunks = 8